// @flow
import * as Cookie from 'app/packages/cookie-utils';

export const hasLoggedOut = () => !!Cookie.get('logged_out');

export const isAutoLoginDisabled = () =>
  hasLoggedOut() || !!Cookie.get(PCONST.COOKIE_FB_AUTO_LOGIN_DISABLED);

// API errors
export const FACEBOOK_ACCOUNT_NOT_LINKED = 105;
export const INCORRECT_PASSWORD_API_CODE = 78;
export const INCORRECT_PASSWORD_THREE_TIMES = 85;
export const INVALID_PASSWORD_GOOGLE_USER = 76;
export const LOGIN_USER_NOT_FOUND = 30;
export const INVALID_PASSWORD_FB_USER = 77;
export const INVALID_EMAIL_ERROR_CODE = 79;
export const USER_IN_SAFE_MODE_ERROR_CODE = 19;
export const USER_RATE_LIMITED_ERROR_CODES = [8, 9];
export const ACCOUNT_ALREADY_LINKED_ERROR_CODE = 101;
